import Smarter from "../components/home/Smarter";
import FirstScreen from "../components/home/FirstScreen";
import ChooseYourPath from "../components/home/ChooseYourPath";
import HomeFooter from "../components/home/HomeFooter";
import HowTaoFlowWorks from "../components/home/HowTaoFlowWorks";
import YieldGraph from "../components/home/YieldGraph";
import Safety from "../components/home/Safety";
import KeyProtectionFeatures from "../components/home/KeyProtectionFeatures";
import FrequentlyAskQuestions from "../components/home/FrequentlyAskQuestions";
import ReadyTo from "../components/home/ReadyTo";
import { useTheme } from "../context/ThemeContext";
import { useEffect } from "react";
import clsx from "clsx";
import AnimatedContent from "../components/AnimatedContent";
import JoinWaitlistModal from "../components/JoinWaitlistModal";
import { useNavigate } from "react-router-dom";

const Home = () => {
    const { theme, toggleTheme } = useTheme();
    const navigate = useNavigate();
    useEffect(() => {
        if (theme === 'light') {
            toggleTheme();
        }
    }, [theme, toggleTheme]);

    const handleJoinWaitlist = () => {
        navigate('/dashboard');
    }

    return (
        <div className="w-full text-white bg-black">
            <FirstScreen />
            <AnimatedContent>
                <div className={clsx(
                    "py-[40px] text-center text-[32px] font-semibold leading-[1.2] border-b border-[#161616] px-[16px] tracking-[-1.28px]",
                    "md:text-[46px] md:tracking-[-1.84px]"
                )}>
                    Your TAO should be doing more.
                </div>
            </AnimatedContent>
            <Smarter />
            <ChooseYourPath />
            <HowTaoFlowWorks />
            <YieldGraph />
            <Safety />
            <KeyProtectionFeatures />
            <FrequentlyAskQuestions />
            <ReadyTo />
            <HomeFooter />
            <JoinWaitlistModal callToAction={handleJoinWaitlist} />
        </div>
    );
};

export default Home;
